import { ca } from '../i18n/ca';
import type { CaptureFilter } from './useReviewFlow';

const FILTERS: CaptureFilter[] = ['all', 'pending', 'problem', 'flagged'];

/**
 * What a review page carries above its pictures and keeps in sight while the
 * page scrolls: how far the review is, which captures the grid shows, and
 * the way into the queue. The review page of the first artifacts had the
 * counter stuck to the top; the platform's own had it once, at the head.
 */
export function ReviewToolbar({
  total,
  reviewed,
  problems,
  filter,
  onFilter,
  onQueue,
}: {
  total: number;
  reviewed: number;
  problems: number;
  filter: CaptureFilter;
  onFilter: (f: CaptureFilter) => void;
  onQueue: () => void;
}) {
  const t = ca.inspectionReviewPage;
  const c = ca.inspectionCampaignReviewPage;
  if (total === 0) return null;
  return (
    <div className="review-toolbar" role="group" aria-label={t.filters.label}>
      <span className="review-progress" role="status">
        {c.progress(reviewed, total, problems)}
      </span>
      <progress max={total} value={reviewed} aria-hidden="true" />
      <span className="row">
        {FILTERS.map((f) => (
          <button
            key={f}
            type="button"
            className={`chip toggle ${filter === f ? 'on' : ''}`}
            aria-pressed={filter === f}
            onClick={() => onFilter(f)}
          >
            {t.filters[f]}
          </button>
        ))}
      </span>
      <span className="grow" />
      {reviewed < total && (
        <button type="button" className="primary" onClick={onQueue}>
          <i className="bi bi-play-fill" aria-hidden="true" /> {t.reviewAll}
        </button>
      )}
    </div>
  );
}
